import { render, staticRenderFns } from "./DiseaseSelect.vue?vue&type=template&id=406d4f40&scoped=true"
import script from "./DiseaseSelect.vue?vue&type=script&lang=js"
export * from "./DiseaseSelect.vue?vue&type=script&lang=js"
import style0 from "./DiseaseSelect.vue?vue&type=style&index=0&id=406d4f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d4f40",
  null
  
)

export default component.exports